import i18n from 'i18next'

export interface TrendModalConfig {
	title: string
	months: string[]
	barLabel: string
	barData: number[]
	barColor: string
	lineLabel?: string
	lineData?: number[]
	lineColor?: string
	unit?: string
}

export const getTrendModalOption = (cfg: TrendModalConfig) => {
	const series: any[] = [
		{
			name: cfg.barLabel,
			type: 'bar',
			data: cfg.barData,
			barMaxWidth: 32,
			itemStyle: { color: cfg.barColor, borderRadius: [3, 3, 0, 0] }
		}
	]

	if (cfg.lineData && cfg.lineLabel) {
		series.push({
			name: cfg.lineLabel,
			type: 'line',
			yAxisIndex: 1,
			data: cfg.lineData,
			smooth: false,
			symbol: 'circle',
			symbolSize: 6,
			lineStyle: {
				width: 2,
				color: '#8B5CF6'
			},
			itemStyle: {
				color: '#fff',
				borderColor: '#8B5CF6',
				borderWidth: 2
			},
			areaStyle: {
				color: {
					type: 'linear',
					x: 0,
					y: 0,
					x2: 0,
					y2: 1,
					colorStops: [
						{
							offset: 0,
							color: 'rgba(139, 92, 246, 0.2)'
						},
						{
							offset: 1,
							color: 'rgba(139, 92, 246, 0.1)'
						}
					]
				}
			},
			label: {
				show: true,
				position: 'top',
				fontSize: 11,
				color: '#8B5CF6',
				formatter: (params: any) => {
					return Number(params.value) === 0 ? '' : `${Number(params.value).toFixed(2)}%`
				}
			}
		})
	}

	return {
		grid: { left: 46, right: cfg.lineData ? 46 : 16, top: 40, bottom: 30 },
		legend: {
			top: 0,
			right: 0,
			itemWidth: 10,
			itemHeight: 10,
			icon: 'roundRect',
			textStyle: { fontSize: 11, color: '#4f5661' }
		},
		tooltip: {
			trigger: 'axis',
			formatter: (params: any[]) => {
				return params
					.map(item => {
						const value = Number(item.value ?? 0)

						const color = item.seriesType === 'line' ? '#8B5CF6' : item.color

						const showValue = item.seriesType === 'line' ? `${value.toFixed(2)}%` : value.toFixed(2)

						return `
					<div style="line-height:32px;">
						<span style="
							display:inline-block;
							width:6px;
							height:6px;
							border-radius:50%;
							background:${color};
							margin-right:6px;
						"></span>
						${item.seriesName}：
						${showValue}
					</div>
				`
					})
					.join('')
			}
		},
		xAxis: {
			type: 'category',
			data: cfg.months,
			axisLine: { lineStyle: { color: '#eef1f6' } },
			axisTick: { show: false },
			axisLabel: { fontSize: 11, color: '#98a0ae' }
		},
		yAxis: [
			{
				type: 'value',
				splitLine: { lineStyle: { color: '#eef1f6' } },
				axisLabel: { fontSize: 11, color: '#98a0ae' }
			},
			{
				type: 'value',
				show: !!cfg.lineData,
				splitLine: { show: false },
				axisLabel: { fontSize: 11, color: '#98a0ae', formatter: `{value}${cfg.unit || ''}` }
			}
		],
		series
	}
}
